(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fs-cognitive-fitness"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('cf-gym'))customElements.define('cf-gym',class extends HTMLElement{
connectedCallback(){this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;this.button=this.querySelector('[data-play]');if(this.button)this.button.hidden=!!this.querySelector('video.cfg__player');this.button?.addEventListener('click',()=>this.play(),{signal});this.querySelector('[data-watch]')?.addEventListener('click',e=>{e.preventDefault();this.querySelector('.cfg__frame').scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});this.play();},{signal});}
play(){let v=this.querySelector('.cfg__screen > video');if(!v){const t=this.querySelector('template');if(!t)return;this.querySelector('.cfg__screen').append(t.content.cloneNode(true));v=this.querySelector('.cfg__screen > video');}if(!v)return;this.button.hidden=true;v.tabIndex=0;v.focus({preventScroll:true});document.dispatchEvent(new CustomEvent('foundry:media-play',{detail:this}));const playback=v.play();if(playback?.catch)playback.catch(()=>{/* Native controls remain available for retry. */});}
disconnectedCallback(){this.querySelector('.cfg__screen > video')?.pause();this.abort?.abort();}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-detail-lens"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fs-detail-lens')) {
    customElements.define(
      'fs-detail-lens',
      class extends HTMLElement {
        connectedCallback() {
          if (this.cleanup) return;

          this.stage = this.querySelector('.fdl__stage');
          if (!this.stage) return;

          this.base = this.querySelector('.fdl__base');
          this.lens = this.querySelector('.fdl__lens');
          this.spots = [...this.querySelectorAll('[data-spot]')];
          this.notes = [...this.querySelectorAll('[data-note]')];
          this.toggle = this.querySelector('[data-lens-toggle]');
          this.close = this.querySelector('[data-close]');
          this.hint = this.querySelector('.fdl__hint');
          this.status = this.querySelector('.fdl__status');

          this.mobileQuery = window.matchMedia('(max-width: 749px)');
          this.enabled = this.dataset.lensEnabled === 'true';
          this.selected = null;
          this.point = null;
          this.ready = false;
          this.loadStarted = false;
          this.suspended = false;
          this.ignoreFocus = false;

          this.setAttribute('data-enhanced', '');

          for (const note of this.notes) {
            note.hidden = true;
          }

          const move = (event) => {
            if (this.mobileQuery.matches || event.pointerType !== 'mouse') {
              return;
            }

            const bounds = this.stage.getBoundingClientRect();
            if (!bounds.width || !bounds.height) return;

            this.point = {
              x: (event.clientX - bounds.left) / bounds.width,
              y: (event.clientY - bounds.top) / bounds.height
            };

            this.suspended = false;

            if (!this.pointerFrame) {
              this.pointerFrame = requestAnimationFrame(() => {
                this.pointerFrame = null;

                if (this.isConnected) {
                  this.draw();
                  this.findSpot();
                }
              });
            }
          };

          const leave = () => {
            cancelAnimationFrame(this.pointerFrame);
            this.pointerFrame = null;
            this.lens.hidden = true;
            this.point = null;
          };

          const click = (event) => {
            const spot = event.target.closest('[data-spot]');

            if (spot && this.spots.includes(spot)) {
              this.choose(spot, true);
              return;
            }

            if (this.mobileQuery.matches) return;

            if (event.target === this.base) {
              const bounds = this.stage.getBoundingClientRect();
              if (!bounds.width || !bounds.height) return;

              this.point = {
                x: (event.clientX - bounds.left) / bounds.width,
                y: (event.clientY - bounds.top) / bounds.height
              };

              this.suspended = false;
              this.draw();
              this.findSpot();
            }
          };

          const focus = (event) => {
            if (this.spots.includes(event.target)) {
              this.choose(event.target, true);
            }
          };

          const toggle = () => {
            if (this.mobileQuery.matches) return;

            this.enabled = !this.enabled;
            this.toggle.setAttribute('aria-pressed', String(this.enabled));

            if (this.enabled) {
              this.point = this.point || { x: 0.5, y: 0.5 };
              this.suspended = false;
              this.draw();
            } else {
              this.lens.hidden = true;
            }
          };

          const dismiss = () => {
            this.selected = null;

            for (const note of this.notes) {
              note.hidden = true;
            }

            for (const spot of this.spots) {
              spot.setAttribute('aria-expanded', 'false');
            }

            this.close.hidden = true;
            this.hint.hidden = false;
            this.lens.hidden = true;
            this.suspended = true;
          };

          const close = () => {
            const prior = this.spots.find(
              (spot) => spot.dataset.spot === this.selected
            );

            dismiss();
            this.ignoreFocus = true;
            prior?.focus({ preventScroll: true });
            this.ignoreFocus = false;
          };

          const key = (event) => {
            if (event.key === 'Escape') {
              close();
            }
          };

          const editor = (event) => {
            const spot = this.spots.find(
              (item) => item.dataset.spot === String(event.detail?.blockId)
            );

            if (spot) {
              this.choose(spot, true);
            }
          };

          const resize = () => {
            if (this.mobileQuery.matches) {
              cancelAnimationFrame(this.pointerFrame);
              this.pointerFrame = null;
              this.lens.hidden = true;
              this.point = null;
              this.status.textContent = '';
              return;
            }

            if (this.point && !this.suspended) {
              this.draw();
            }
          };

          this.stage.addEventListener('pointermove', move);
          this.stage.addEventListener('pointerleave', leave);
          this.stage.addEventListener('click', click);
          this.stage.addEventListener('focusin', focus);
          this.toggle.addEventListener('click', toggle);
          this.close.addEventListener('click', close);
          this.addEventListener('keydown', key);
          document.addEventListener('shopify:block:select', editor);
          window.addEventListener('resize', resize);
          this.mobileQuery.addEventListener('change', resize);

          this.observer =
            typeof ResizeObserver === 'function'
              ? new ResizeObserver(resize)
              : null;

          this.observer?.observe(this.stage);

          this.cleanup = () => {
            this.stage.removeEventListener('pointermove', move);
            this.stage.removeEventListener('pointerleave', leave);
            this.stage.removeEventListener('click', click);
            this.stage.removeEventListener('focusin', focus);
            this.toggle.removeEventListener('click', toggle);
            this.close.removeEventListener('click', close);
            this.removeEventListener('keydown', key);
            document.removeEventListener('shopify:block:select', editor);
            window.removeEventListener('resize', resize);
            this.mobileQuery.removeEventListener('change', resize);
            this.observer?.disconnect();

            if (this.loader) {
              this.loader.onload = null;
              this.loader.onerror = null;
            }
          };
        }

        choose(spot, center) {
          if (this.ignoreFocus) return;

          if (this.selected !== spot.dataset.spot) {
            this.selected = spot.dataset.spot;

            for (const note of this.notes) {
              note.hidden = note.dataset.note !== this.selected;
            }

            for (const item of this.spots) {
              item.setAttribute(
                'aria-expanded',
                String(item === spot)
              );
            }

            this.hint.hidden = true;
            this.close.hidden = false;
          }

          if (center && !this.mobileQuery.matches) {
            this.point = {
              x: Number(spot.dataset.x) / 100,
              y: Number(spot.dataset.y) / 100
            };

            this.suspended = false;
            this.draw();
          }
        }

        findSpot() {
          if (this.mobileQuery.matches || !this.point) return;

          const bounds = this.stage.getBoundingClientRect();
          let best = null;
          let distance = Infinity;

          for (const spot of this.spots) {
            const dx =
              (this.point.x - Number(spot.dataset.x) / 100) * bounds.width;
            const dy =
              (this.point.y - Number(spot.dataset.y) / 100) * bounds.height;
            const candidateDistance = Math.hypot(dx, dy);
            const reach =
              Math.min(bounds.width, bounds.height) *
              Number(spot.dataset.reach) / 100;

            if (candidateDistance < reach && candidateDistance < distance) {
              best = spot;
              distance = candidateDistance;
            }
          }

          if (best) {
            this.choose(best, false);
          }
        }

        loadZoom() {
          if (this.mobileQuery.matches || this.loadStarted) return;

          this.loadStarted = true;
          this.status.textContent = 'Loading detail…';
          this.loader = new Image();

          this.loader.onload = () => {
            if (!this.isConnected) return;

            const baseRatio =
              this.base.naturalWidth / this.base.naturalHeight;
            const zoomRatio =
              this.loader.naturalWidth / this.loader.naturalHeight;

            if (
              Number.isFinite(baseRatio) &&
              Math.abs(baseRatio / zoomRatio - 1) > 0.015
            ) {
              this.status.textContent =
                'Use a zoom image with the same artwork and crop as the main image.';
              return;
            }

            this.ready = true;
            this.lens.style.backgroundImage =
              `url("${this.loader.src.replace(/"/g, '%22')}")`;
            this.status.textContent = '';

            if (this.point && !this.suspended) {
              this.draw();
            }
          };

          this.loader.onerror = () => {
            if (this.isConnected && !this.mobileQuery.matches) {
              this.status.textContent =
                'The detail image could not load.';
            }
          };

          this.loader.src =
            this.dataset.zoomSrc ||
            this.base.currentSrc ||
            this.base.src;
        }

        draw() {
          if (
            this.mobileQuery.matches ||
            !this.enabled ||
            !this.point ||
            this.suspended
          ) {
            this.lens.hidden = true;
            return;
          }

          if (!this.ready) {
            this.loadZoom();
            return;
          }

          const bounds = this.stage.getBoundingClientRect();
          if (!bounds.width || !bounds.height) return;

          const size = Math.min(
            Number(this.dataset.diameter) || 220,
            bounds.width,
            bounds.height
          );

          const half = size / 2;
          const zoom = Math.max(
            1.2,
            Math.min(4, Number(this.dataset.zoom) || 2)
          );

          const clamp = (value, min, max) =>
            Math.max(min, Math.min(max, value));

          const x = clamp(this.point.x * bounds.width, 0, bounds.width);
          const y = clamp(this.point.y * bounds.height, 0, bounds.height);

          this.lens.style.width = `${size}px`;
          this.lens.style.height = `${size}px`;

          this.lens.style.left =
            `${clamp(x - half, 0, bounds.width - size)}px`;

          this.lens.style.top =
            `${clamp(y - half, 0, bounds.height - size)}px`;

          this.lens.style.backgroundSize =
            `${bounds.width * zoom}px ${bounds.height * zoom}px`;

          this.lens.style.backgroundPosition =
            `${half - clamp(x, half / zoom, bounds.width - half / zoom) * zoom}px ` +
            `${half - clamp(y, half / zoom, bounds.height - half / zoom) * zoom}px`;

          this.lens.hidden = false;
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.pointerFrame);
          this.pointerFrame = null;
          this.cleanup?.();
          this.cleanup = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-kit-tabs"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('fs-kit-tabs')) {
  customElements.define('fs-kit-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.tabs = [...this.querySelectorAll('[data-fkt-tab]')];
      this.panels = [...this.querySelectorAll('[data-fkt-panel]')];
      if (!this.tabs.length) return;
      this.active = 0;
      this.list = this.querySelector('.fkt__tabs');
      this.line = this.querySelector('.fkt__underline');
      this.list.setAttribute('role', 'tablist');
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', this.panels[i].id);
        this.panels[i].setAttribute('role', 'tabpanel');
        this.panels[i].setAttribute('aria-labelledby', tab.id);
        this.panels[i].tabIndex = 0;
      });
      this.setAttribute('data-enhanced', '');
      const click = e => {
        const tab = e.target.closest('[data-fkt-tab]');
        const i = this.tabs.indexOf(tab);
        if (i >= 0) this.select(i, true);
      };
      const key = e => {
        const i = this.tabs.indexOf(e.target);
        if (i < 0) return;
        const rtl = getComputedStyle(this).direction === 'rtl';
        let next;
        if (e.key === 'ArrowRight') next = i + (rtl ? -1 : 1);
        if (e.key === 'ArrowLeft') next = i + (rtl ? 1 : -1);
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        e.preventDefault();
        next = (next + this.tabs.length) % this.tabs.length;
        this.tabs[next].focus({ preventScroll: true });
        this.select(next, true);
      };
      const blockSelect = e => {
        const i = this.tabs.findIndex(tab => tab.dataset.fktTab === String(e.detail?.blockId));
        if (i >= 0) this.select(i, false);
      };
      this.list.addEventListener('click', click);
      this.list.addEventListener('keydown', key);
      document.addEventListener('shopify:block:select', blockSelect);
      const measure = () => this.measure();
      window.addEventListener('resize', measure);
      this.observer = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
      this.observer?.observe(this.list);
      this.select(0, false);
      this.frame = requestAnimationFrame(measure);
      this.cleanup = () => {
        this.list.removeEventListener('click', click);
        this.list.removeEventListener('keydown', key);
        document.removeEventListener('shopify:block:select', blockSelect);
        window.removeEventListener('resize', measure);
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.animations?.forEach(animation => animation.cancel());
      };
    }
    measure() {
      const tab = this.tabs[this.active];
      const t = tab.getBoundingClientRect(), l = this.list.getBoundingClientRect();
      this.line.style.width = `${t.width}px`;
      this.line.style.transform = `translateX(${t.left - l.left}px)`;
    }
    select(index, motion) {
      const changed = index !== this.active;
      this.animations?.forEach(animation => animation.cancel());
      this.active = index;
      for(const template of this.panels[index].querySelectorAll('template[data-deferred-image]')){template.replaceWith(template.content.cloneNode(true));}
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
      this.measure();
      const nav = this.querySelector('.fkt__nav');
      const t = this.tabs[index].getBoundingClientRect(), n = nav.getBoundingClientRect();
      if (t.left < n.left) nav.scrollLeft += t.left - n.left;
      else if (t.right > n.right) nav.scrollLeft += t.right - n.right;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (changed && motion && this.dataset.motion !== 'false' && !reduced) {
        const duration = Math.max(0, Math.min(1000, Number(this.dataset.duration) || 400));
        this.animations = [...this.panels[index].children].map(el => el.animate?.(
          [{ opacity: 0, transform: 'translateY(10px) scale(.98)' }, { opacity: 1, transform: 'translateY(0) scale(1)' }],
          { duration, easing: 'cubic-bezier(.24,.02,.13,1)' }
        )).filter(Boolean);
      }
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-yearbook"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('fs-yearbook')) {
 customElements.define('fs-yearbook',class extends HTMLElement {
  connectedCallback(){
   if(this.cleanup)return;
   this.setAttribute('data-enhanced','');
   const listeners=[];
   const listen=(el,name,fn)=>{el.addEventListener(name,fn);listeners.push(()=>el.removeEventListener(name,fn));};
   const entries=[...this.querySelectorAll('.fyb__card')].map(card=>({card,details:card.querySelector('details'),summary:card.querySelector('summary'),pinned:false})).filter(e=>e.details);
   const close=e=>{e.details.open=false;e.pinned=false;};
   const open=e=>{entries.forEach(other=>{if(other!==e)close(other);});e.details.open=true;};
   const fine=()=>window.matchMedia('(hover: hover) and (pointer: fine)').matches;
   entries.forEach(e=>{
    listen(e.card,'pointerenter',event=>{if(event.pointerType==='mouse'&&fine())open(e);});
    listen(e.card,'pointerleave',()=>{if(!e.pinned&&!e.card.contains(document.activeElement))close(e);});
    listen(e.summary,'click',event=>{event.preventDefault();if(e.pinned){close(e);}else{open(e);e.pinned=true;}});
    listen(e.card,'focusout',event=>{if(!e.card.contains(event.relatedTarget)&&!e.pinned)close(e);});
    listen(e.card,'keydown',event=>{if(event.key==='Escape'){close(e);e.summary.focus({preventScroll:true});}});
   });
   listen(document,'pointerdown',event=>{entries.forEach(e=>{if(!e.card.contains(event.target))close(e);});});
   listen(document,'shopify:block:select',event=>{const e=entries.find(e=>e.card.dataset.person===String(event.detail?.blockId));if(e){open(e);e.pinned=true;}});
   this.cleanup=()=>listeners.forEach(remove=>remove());
  }
  disconnectedCallback(){this.cleanup?.();this.cleanup=null;}
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
